import styled from 'styled-components';
import { Dropdown as DropdownComponent } from 'react-bootstrap';

export const Dropdown = styled(DropdownComponent)`
  .dropdown-menu {
    z-index: 999999;
  }
`;
